const queryParamRegex = /'&([A-Za-z]\w*?)'/g;
module.exports = queryParamRegex;
